export class SoldOutItemsError extends Error {
  readonly soldOutItemsUuids: string[];
  constructor(message: string, soldOutItemsUuids: string[]) {
    super(message);
    this.soldOutItemsUuids = soldOutItemsUuids;
  }
}
